var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33333 1.33333H13.3333V6.66667V13.3333H6.66667H1.33333V1.33333ZM5.33333 14.6667H1.33333H0V13.3333V1.33333V0H1.33333H13.3333H14.6667V1.33333V5.33333H18.6667H20V6.66667V18.6667V20H18.6667H6.66667H5.33333V18.6667V14.6667ZM14.6667 6.66667V13.3333V14.6667H13.3333H6.66667V18.6667H18.6667V6.66667H14.6667Z",
    fill: "#007CBE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xLjMzMzMzIDEuMzMzMzNIMTMuMzMzM1Y2LjY2NjY3VjEzLjMzMzNINi42NjY2N0gxLjMzMzMzVjEuMzMzMzNaTTUuMzMzMzMgMTQuNjY2N0gxLjMzMzMzSDBWMTMuMzMzM1YxLjMzMzMzVjBIMS4zMzMzM0gxMy4zMzMzSDE0LjY2NjdWMS4zMzMzM1Y1LjMzMzMzSDE4LjY2NjdIMjBWNi42NjY2N1YxOC42NjY3VjIwSDE4LjY2NjdINi42NjY2N0g1LjMzMzMzVjE4LjY2NjdWMTQuNjY2N1pNMTQuNjY2NyA2LjY2NjY3VjEzLjMzMzNWMTQuNjY2N0gxMy4zMzMzSDYuNjY2NjdWMTguNjY2N0gxOC42NjY3VjYuNjY2NjdIMTQuNjY2N1oiIGZpbGw9IiMwMDdDQkUiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };